import Joi from 'joi';

export const WebinarWizardDataSchema = Joi.object({
  name: Joi.string(),
  description: Joi.string(),
  date: Joi.string(),
  time: Joi.string(),
  duration: Joi.string(),
  timezone: Joi.string(),
  branding: Joi.object({
    logo: Joi.string(),
    image: Joi.string(),
    theme: Joi.string(),
  }),
  speakers: Joi.array().items(
    Joi.object({
      email: Joi.string(),
      firstName: Joi.string(),
      lastName: Joi.string(),
      company: Joi.string(),
      title: Joi.string(),
      image: Joi.string(),
    })
  ),
});

export const WebinarWizardAiOptionSchema = Joi.object({
  title: Joi.string(),
  description: Joi.string(),
});

